// extracted by mini-css-extract-plugin
export default {"pageContainer":"ChargebackPage_pageContainer__ow+J+","iframeContainer":"ChargebackPage_iframeContainer__gQPGB"};